import { Attachment } from '@/models/Attachment';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { AttachmentRequest, AttachmentsTypes } from './types';

export const getAttachmentListRequest = (requestData: AttachmentRequest) => action(AttachmentsTypes.GET_ATTACHMENTS_REQUEST, requestData);
export const getAttachmentListSuccess = (attachmentsData: Attachment[]) => action(AttachmentsTypes.GET_ATTACHMENTS_SUCCESS, attachmentsData);
export const getAttachmentListFailure = () => action(AttachmentsTypes.GET_ATTACHMENTS_FAILURE);

export const postAttachmentRequest = (attachment: Attachment) => action(AttachmentsTypes.POST_ATTACHMENT_REQUEST, attachment);
export const postAttachmentSuccess = (attachment: Attachment) => action(AttachmentsTypes.POST_ATTACHMENT_SUCCESS, attachment);
export const postAttachmentFailure = () => action(AttachmentsTypes.POST_ATTACHMENT_FAILURE);

export const addAttachmentToList = (data: Attachment) => action(AttachmentsTypes.ADD_TO_ATTACHMENT_LIST, data);
export const removeAttachmentFromList = (id: number) => action(AttachmentsTypes.REMOVE_ATTACHMENT_FROM_LIST, id);

export const attachmentsClear = () => action(AttachmentsTypes.ATTACHMENTS_CLEAR);

export const removeAttachmentRequest = (id: number) => action(AttachmentsTypes.REMOVE_ATTACHMENT_REQUEST, id);
export const removeAttachmentSuccess = (id: number) => action(AttachmentsTypes.REMOVE_ATTACHMENT_SUCCESS, id);
export const removeAttachmentFailure = (error: AxiosError) => action(AttachmentsTypes.REMOVE_ATTACHMENT_FAILURE, error);

export const putAttachmentRequest = (data: AttachmentRequest) => action(AttachmentsTypes.PUT_ATTACHMENT_REQUEST, data);
export const putAttachmentSuccess = (data: AttachmentRequest) => action(AttachmentsTypes.PUT_ATTACHMENT_SUCCESS, data);
export const putAttachmentFailure = (error: AxiosError) => action(AttachmentsTypes.PUT_ATTACHMENT_FAILURE, error);
